import {
  AUTO_PARTS_TIRES_ACCESSORIES_CATEGORIES,
  AUTOMOTIVE_SERVICES_CATEGORIES,
  CARS_VEHICLES_L1,
  CARS_VEHICLES_L2,
  CARS_VEHICLES_L3,
} from '@kijiji/category'
import { type StaticImageData } from 'next/image'

import { type TrackEventArgs } from '@/lib/ga'
import { GA_EVENT } from '@/lib/ga/constants/gaEvent'
import dealerFinancingImage from '~/public/next-assets/images/dealer-financing.png'
import dealerTradeInImage from '~/public/next-assets/images/dealer-trade-in.png'

export enum BannerType {
  FINANCING = 'financing',
  TRADEIN = 'tradeIn',
}

type DealerRequestCtaAssetsType = Record<
  BannerType,
  {
    image: StaticImageData
    title: string
    description: string
    buttonText: string
    trackingParameters: TrackEventArgs
  }
>

export const DEALER_REQUEST_CTA_ASSETS: DealerRequestCtaAssetsType = {
  [BannerType.FINANCING]: {
    image: dealerFinancingImage,
    title: 'vip:financing.title',
    description: 'vip:financing.description',
    buttonText: 'vip:dealer_request.inquiry_label',
    trackingParameters: { action: GA_EVENT.AutoFinancingShow },
  },
  [BannerType.TRADEIN]: {
    image: dealerTradeInImage,
    title: 'trade_in:cta.title',
    description: 'trade_in:cta.description',
    buttonText: 'vip:dealer_request.inquiry_label',
    trackingParameters: { action: GA_EVENT.AutosCtaClick, label: `cta=tradein` },
  },
}

/** Converting the array into a set for faster value lookup in the TRADE_IN_CATEGORIES filter function  */
const EXCLUDED_CATEGORIES = new Set([
  AUTO_PARTS_TIRES_ACCESSORIES_CATEGORIES,
  ...AUTOMOTIVE_SERVICES_CATEGORIES,
])

export const TRADE_IN_CATEGORIES = [
  CARS_VEHICLES_L1,
  ...CARS_VEHICLES_L2,
  ...CARS_VEHICLES_L3,
].filter((id) => !EXCLUDED_CATEGORIES.has(id))
